import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import {
  Constants,
  LocaleService,
  LocalStoragerService,
  SessionStoragerService,
} from '../../_utility';
import { AuthService } from '../../_services';
import { Languages } from '../../_models';

@Component({
  standalone: false,
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class LandingComponent implements OnInit {
  token!: string;
  shipId!: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private spinner: SpinnerService,
    private sStore: SessionStoragerService,
    private locale: LocaleService,
    private lStore: LocalStoragerService
  ) { }
  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
      if (param) {
        this.token = param['key'];
        this.shipId = param['shipId'];
        if (this.token && this.shipId) {
          this.SignIn();
        } else {
          setTimeout(
            () => this.router.navigate(Constants.Routing.LOGIN.routerLink),
            1000
          );
        }
      }
    });
  }

  goTo() {
    if (this.auth.token) {
      this.router.navigate(Constants.Routing.HOME.routerLink);
    } else {
      this.router.navigate(Constants.Routing.LOGIN.routerLink);
    }
  }

  SignIn() {
    this.spinner.show();
    let body = { key: this.token, shipId: this.shipId };
    this.auth.SignIn(body).subscribe({
      next: (res: any) => {
        this.sStore.clearAll();
        this.auth.setUserInfo(res.auth);
        this.sStore.setElement(Constants.Storager.AUTOLOGIN, true);
        this.lStore.setElement(Constants.Storager.SHIPID, this.shipId);

        if (res.language) {
          let lang = res.language;
          if (!Object.values(Languages).includes(lang as Languages)) {
            lang = Languages.default;
          }
          this.locale.changeLanguage(lang);
        }

        if (res.data) {
          if (res.data.restaurant) {
            this.sStore.setElement(
              Constants.Storager.RESTAURANT,
              res.data.restaurant
            );
          }
          if (res.data.phone) {
            this.sStore.setElement(
              Constants.Storager.PHONE_NUMBER,
              res.data.phone
            );
          }
        }
        this.spinner.hide();
        return this.router.navigate(Constants.Routing.SELECT_USER.routerLink);
      },
      error: (err) => {
        this.spinner.hide();
        if (this.shipId && Constants.SHIPS.some((e) => e.id === this.shipId)) {
          this.router.navigate(Constants.Routing.LOGIN.routerLink, {
            queryParamsHandling: 'preserve',
          });
        }
      },
    });
  }
}
